import script from "./AvatarControls.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarControls.vue?vue&type=script&setup=true&lang=js"

import "./AvatarControls.vue?vue&type=style&index=0&id=bff119ec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bff119ec"]])

export default __exports__